import { combineReducers } from 'redux';
import transaction from './transaction/index';

const rootReducer = combineReducers({
    transaction,
});

export default rootReducer;
